var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 14,
    viewBox: "0 0 25 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.60866C2.00884 9.67052 4.83377 8.24897 5.11357 8.13436C8.09473 6.91316 10.9318 6.82501 14.1038 6.82501C15.962 6.82501 17.7186 7.25162 19.0731 5.89712C19.3169 5.65335 19.6601 5.45462 19.0319 5.34039C17.8732 5.12972 16.7393 4.59852 15.7121 4.02073C14.8617 3.54239 14.0978 2.98417 13.3202 2.41239C13.1709 2.30263 12.2334 2 12.6604 2C15.4684 2 18.2814 4.44899 20.6608 5.71154C21.0239 5.90419 23.2539 6.55227 22.4547 6.86625C21.5735 7.21246 20.813 7.92871 20.0216 8.43334C18.7244 9.26054 17.6567 10.5447 16.3719 11.2789C16.0405 11.4682 15.4007 12.285 15.176 11.8356",
    stroke: "#DA494C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.3c9566beae4a84b4d6d520ddb6ae1a2a.svg";
export { ForwardRef as ReactComponent };